module.exports = __webpack_public_path__ + "teqbahn-assets/media/icon.2a7b9964.png";